"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    AccordionSize: function() {
        return AccordionSize;
    },
    default: function() {
        return _default;
    }
});
var _react = /*#__PURE__*/ _interopRequireDefault(require("react"));
var _classnames = /*#__PURE__*/ _interopRequireDefault(require("classnames"));
var _icon = require("../Icon");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var AccordionSize;
(function(AccordionSize) {
    AccordionSize[AccordionSize["BIG"] = 0] = "BIG";
    AccordionSize[AccordionSize["COMPACT"] = 1] = "COMPACT";
})(AccordionSize || (AccordionSize = {}));
var AccordionItem = function(param) {
    var position = param.position, _param_size = param.size, size = _param_size === void 0 ? AccordionSize.BIG : _param_size, Header = param.Header, headerClasses = param.headerClasses, Content = param.Content, contentClasses = param.contentClasses, _param_disabled = param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled, _param_active = param.active, active = _param_active === void 0 ? false : _param_active, _param_fullWidth = param.fullWidth, fullWidth = _param_fullWidth === void 0 ? false : _param_fullWidth, onHeaderClick = param.onHeaderClick, openNextItem = param.openNextItem, openPreviousItem = param.openPreviousItem, stepId = param.stepId;
    var classes = {
        container: (0, _classnames.default)("flex flex-col"),
        header: (0, _classnames.default)("group flex items-center justify-between cursor-pointer transition-spacing ease-in-out duration-300", {
            "pointer-events-none": disabled,
            "p-5 md:p-6": size === AccordionSize.BIG,
            "p-2": size === AccordionSize.COMPACT
        }, headerClasses),
        content: (0, _classnames.default)("flex flex-col transition-spacing ease-in-out duration-300", {
            hidden: !active,
            "px-5 pb-5 md:px-20 md:pb-10": size === AccordionSize.BIG && !fullWidth,
            "pb-6 px-6": size === AccordionSize.BIG && fullWidth,
            "p-2": size === AccordionSize.COMPACT
        }, contentClasses),
        chevronUp: (0, _classnames.default)("flex items-center justify-center", {
            "w-6 h-6": size === AccordionSize.BIG,
            "w-3 h-3": size === AccordionSize.COMPACT
        }),
        chevronUpIcon: (0, _classnames.default)("transition group-hover:text-gray-900", {
            "text-gray-400 rotate-180": !active,
            "text-gray-900": active,
            hidden: disabled
        })
    };
    var HeaderElement = _react.default.Children.only(Header);
    var ContentElement = _react.default.Children.only(Content);
    return /*#__PURE__*/ _react.default.createElement("div", {
        className: classes.container
    }, /*#__PURE__*/ _react.default.createElement("a", {
        id: stepId,
        href: "#".concat(stepId),
        className: classes.header,
        onClick: function(event) {
            return onHeaderClick(event, stepId, position);
        }
    }, /*#__PURE__*/ _react.default.createElement(HeaderElement.type, _extends({}, HeaderElement.props, {
        active: active,
        disabled: disabled,
        position: position,
        size: size,
        openNextItem: openNextItem,
        openPreviousItem: openPreviousItem
    })), /*#__PURE__*/ _react.default.createElement("span", {
        className: classes.chevronUp
    }, /*#__PURE__*/ _react.default.createElement(_icon.ChevronUp, {
        className: classes.chevronUpIcon
    }))), /*#__PURE__*/ _react.default.createElement("div", {
        className: classes.content
    }, active ? /*#__PURE__*/ _react.default.createElement(ContentElement.type, _extends({}, ContentElement.props, {
        position: position,
        size: size,
        active: active,
        disabled: disabled,
        openNextItem: openNextItem,
        openPreviousItem: openPreviousItem
    })) : null));
};
AccordionItem.displayName = "AccordionItem";
var _default = AccordionItem;

//# sourceMappingURL=AccordionItem.js.map